<template>
  <div class="modal" :class="modal.class" v-if="modal.status" @click="closeModal()">
    <div @click.stop="">
      <component :is="modal.component"></component>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Conflicts from '@/components/modal/Conflicts'
import Delete from '@/components/modal/Delete'
import Details from '@/components/modal/Details'
import Copy from '@/components/modal/Copy'

export default {
  components: {
    Conflicts,
    Delete,
    Details,
    Copy,
  },
  computed: {
    ...mapGetters(['modal'])
  },
  methods: {
    ...mapMutations(['closeModal']),
    handleKeyDown(event) {
      if (event.keyCode === 27) {
        event.preventDefault();
        this.closeModal();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
}
</script>